export const aiSearchProductName = 'SciAI Search';
export const aiSearchEmptyOrgTooltip =
  'This organisation has no people or activities to search';

const CONTACT = 'contact';

export function getResearcherText({
  isPlural = false,
  capitalize = false,
} = {}) {
  let text = isPlural ? `${CONTACT}s` : CONTACT;

  if (capitalize) {
    text = text.charAt(0).toUpperCase() + text.slice(1);
  }

  return text;
}

export const UpgradeLicense = ({
  label = 'Upgrade License',
  additionalText = 'For Access',
}) => (
  <span>
    <a
      href='https://scileads.com/get-started/'
      target='_blank'
      rel='noopener noreferrer'
    >
      {label}
    </a>{' '}
    {additionalText}
  </span>
);
